const tracking={
    userInfo(that,pInfo,pInfoNew){
        
        if(pInfo)pInfo.phoneNumber=pInfo.phoneNumber||pInfo.mobile;
        that.braze.getUser().setFirstName(pInfo.nickname);
        that.braze.getUser().setLastName(pInfo.surname)
        that.braze.getUser().setGender(pInfo.gender==0?"m":"f");
        
       
        that.braze.getUser().setEmail(pInfo.email);

        if(pInfo.phoneNumber||(pInfoNew&&pInfoNew.phoneNumber)){
            that.braze.getUser().setPhoneNumber((pInfo.phoneNumber?pInfo.phoneNumber:pInfoNew.phoneNumber));
        }
        if(pInfo.birthday){
            that.braze.getUser().setDateOfBirth(pInfo.birthday.split("-")[0]*1,pInfo.birthday.split("-")[1]*1,pInfo.birthday.split("-")[2]*1);
        }else if(pInfo.birthdayDate){
            pInfo.birthday=pInfo.birthdayDate;
            that.braze.getUser().setDateOfBirth(pInfo.birthday.split("-")[0]*1,pInfo.birthday.split("-")[1]*1,pInfo.birthday.split("-")[2]*1);
        }
        // that.braze.requestPushPermission();
        // that.braze.isPushSupported()
    },
    setId(that,id){
        // console.log(id)
        if(!id){
            that.braze.changeUser(" ")
        }else{
            that.braze.changeUser(id);
        }
    },
    setCustomAtt(that,pKey,pValue){        
        that.braze.getUser().setCustomUserAttribute(
            pKey,
            pValue
        );
    },
    locationTrack(that,coords){
        that.braze.getUser().setLastKnownLocation(
            coords.latitude,
            coords.longitude,
            coords.accuracy,
            coords.altitude,
            coords.altitudeAccuracy
          );
    },

}
export default tracking;